import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#070A28",
      d: "M15.309 13.405a8.47 8.47 0 0 0-4.72-3.807 5.063 5.063 0 1 0-5.177 0c-1.989.644-3.67 2-4.72 3.807a.562.562 0 0 0 .488.844h13.642a.563.563 0 0 0 .487-.844"
    }, null, -1)
  ])))
}
export default { render: render }